import React from 'react';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from '@/Components/ui/dialog';

import BroadcastPanel from './BroadcastPanel';

/**
 * BroadcastDialog — the Broadcast panel in a modal, for every place a job
 * can be broadcast from (after posting, the My Jobs row menu, the
 * applications header).
 *
 * `onStateChange` receives the latest panel state after each change so the
 * opener can keep its own "is this job public" indicators in sync.
 */
export default function BroadcastDialog({ jobId, open, onOpenChange, onStateChange }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-h-[90vh] max-w-2xl overflow-y-auto p-6">
        {/* The panel renders its own visible heading; these name the dialog
            for screen readers. */}
        <DialogTitle className="sr-only">Broadcast this job</DialogTitle>
        <DialogDescription className="sr-only">
          Publish the job, choose where it is listed and share it with your network.
        </DialogDescription>
        {open && jobId ? <BroadcastPanel jobId={jobId} onStateChange={onStateChange} /> : null}
      </DialogContent>
    </Dialog>
  );
}
